"use client";

import { FeedFilter, FilterType } from "./FeedFilter";

import { useExperiment } from "statsig-react";

interface FeedHeaderProps {
  isLoggedOut: boolean;
  /**
   * True when the brand-moment hero above the feed owns the page's h1 — the
   * "Your Feed" title is hidden and only the filter row renders.
   */
  hideTitle?: boolean;
  activeFilter: FilterType;
  onFilterChange: (filter: FilterType) => void;
  showMyComediansFilter?: boolean;
}

export function FeedHeader({
  isLoggedOut,
  hideTitle = false,
  activeFilter,
  onFilterChange,
  showMyComediansFilter = false,
}: FeedHeaderProps) {
  return (
    <div
      className={`px-4 md:px-0 flex flex-row items-center ${
        // Under the brand hero the filter aligns with the hero's text edge at
        // every breakpoint — one shared left rhythm down the page.
        hideTitle ? "justify-start" : "justify-between"
      }`}
    >
      {!hideTitle && (
        <h1 className="font-sans text-slate-gray-900 font-semibold text-[26px] normal-case leading-none">
          Your Feed
        </h1>
      )}
      <FeedFilter
        isLoggedOut={isLoggedOut}
        activeFilter={activeFilter}
        onFilterChange={onFilterChange}
        showMyComediansFilter={showMyComediansFilter}
      />
    </div>
  );
}
